export class AppConsts {
    static appBaseUrl: string = 'https://api-dev.biztime.ir';
    static projectId: string = 'pv8ur0d2yj';
    static environment: string = 'development';
    static apiVersion: string = 'v1';
    static CRISP_WEBSITE_ID: string = '18419108-1432-400d-87a6-eabbcf6345d4';
    static reCaptchaKey: string = '6Lcad8IqAAAAAKchfz0GALoP_YNQj9oaE52hIHWk';
    static getApiUrl(endpoint: string): string {
        return `${this.appBaseUrl}/${this.apiVersion}/${endpoint}`;
    }
}
